import React, { useState, useEffect } from "react";
import "./styles.css";
import { Grid, Image } from "semantic-ui-react";
import { getCurrency } from "../../../../../../redux/actions/currencySelect";
import {
  formatCurrency,
  formatterUSD,
} from "../../../../../../commons/functions/generalFunctions";
import { connect } from "react-redux";
const { Column, Row } = Grid;
const CheckoutInvoiceItem = ({
  price,
  title,
  quantity,
  image,
  getCurrency,
  currencySelect,
  code,
}) => {
  const [currencyValue, setCurrencyValue] = useState(0);

  useEffect(() => {
    getCurrency();
  }, [getCurrency]);
  useEffect(() => {
    if (currencySelect.currency.currency === "USD") {
      setCurrencyValue(currencySelect.currency.currencyLayer);
    } else {
      setCurrencyValue(0);
    }
  }, [currencySelect]);
  return (
    <div>
      <Grid>
        <Row>
          <Column largeScreen={6} computer={4} tablet={4} mobile={6}>
            <Image
              className="checkout-product-image"
              style={{
                backgroundImage: `url(${image})`,
              }}
            />
          </Column>
          <Column largeScreen={10} computer={12} tablet={12} mobile={10}>
            <h6 className="checkout-product-title">{title}</h6>
            <h6 className="checkout-product-title">{code}</h6>
            <Grid>
              <Row columns={2}>
                <Column largeScreen={8} computer={8} tablet={8} mobile={8}>
                  <p className="checkout-product-price">
                    {!currencySelect || currencySelect.loading
                      ? "Cargando..."
                      : currencyValue === 0
                      ? formatCurrency(Math.ceil(price) * quantity)
                      : formatterUSD.format(
                          (Math.ceil(price / currencyValue.data.value) - 0.01) *
                            quantity
                        )}
                  </p>
                </Column>
                <Column largeScreen={8} computer={8} tablet={8} mobile={8}>
                  <p className="float-right">Cantidad: {quantity}</p>
                </Column>
              </Row>
            </Grid>
          </Column>
        </Row>
      </Grid>
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    currencySelect: state.currencySelect,
    shippingCost: state.payment.shippingCost,
  };
};

export default connect(mapStateToProps, { getCurrency })(CheckoutInvoiceItem);
